import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom"
import { useSelector } from "react-redux";

import Header from "@components/Header/Header"
import PedidosHeader from "./BBs/PedidosHeader/PedidosHeader"

import { emptyResourceRedirect } from "@helpers/navigate"

const PedidosWrapper = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  // Configuración de módulo de pedidos.
  const configuration = useSelector((state) => (state as any).configurations).config;
  const isPedidosActivated = configuration?.modulos?.pedidos ?? false

  // Cargado recursos.
  const [ready, setReady] = useState(false)

  useEffect(() => {
    const checkNoResources = !configuration?.modulos
    emptyResourceRedirect({ check: checkNoResources, path: pathname, navigate })
    setReady(true)
  }, [])

  if (!ready) return (<></>)

  return (
    <>
      <Header />
      {isPedidosActivated ? (
        <>
          <PedidosHeader />
          <div className="center">
            <Outlet />
          </div>
        </>
      ) : (
        <>
          <div className="center">
            <h1>No tienes el módulo de pedidos activado.</h1>
          </div>
        </>
      )}
    </>
  )
}

export default PedidosWrapper